<template>
	<div class="ReSearchFlatsGrid">		
		<div class="grid-container"> 

			<table v-if="!$GVO.isEmpty(objData)">
				<tbody class="flatsBody">
					<tr v-html="strHtmlCorpusName" class="corpus-title p-2"></tr>
					<tr valign="top" class="section-title p-2">
						<th>&nbsp;</th>
						<td 
							v-for="(row,r_index) in strHtmlAllSectionNames"
							:key="r_index"
							v-html="row"></td>
					</tr>
					<tr valign="bottom">
						<th v-html="strHtmlFloorNumbers"></th>
						<td class="section-col" 
							v-for="(row,r_index) in strHtmlAllSections"
							:key="r_index"
							v-html="row"></td>
					</tr>
				</tbody>
			</table>

		</div>
	</div>

</template>

<script>

export default {
	name: 'ReSearchFlatsGrid',
	components: {   
         			
	},
	props: {
		objData: Object,
		objFlatsPrintData: Object,
		findId: { //это свойсво удалять не надо, оно хорошее и моет быть использовано в опуиях для формпринтера или фильтрпринтера
			type: String,
			default: '',
		},
	},
	data () {
		return {
			ver: 1,
			strHtmlCorpusName:'',
			strHtmlFloorNumbers: '',
			strHtmlAllSections:[],
			strHtmlAllSectionNames:[],
		}
	},
	watch: {
		objData(val){
			this.PrepareChessData();
		}
	},
	computed: {
		strDopGet: function(){
			const objGet = this.$GVO.GetAllGet();
			let strGetRet = '';
			if(typeof objGet.task_id != 'undefined' && typeof objGet.taskend_id != 'undefined' && typeof objGet.client_id != 'undefined'){
				strGetRet = `?task_id=${objGet.task_id}&taskend_id=${objGet.taskend_id}&client_id=${objGet.client_id}`;
			}
			return strGetRet;
		},
	},
	methods: {
		PrepareChessData(){
			/*
				https://test.reactor.anspb.com:8081/data/module/sso/object/complex/Akvilon-SKY?task_id=360&taskend_id=389&client_id=2&dSearchType=chess&dSortType=actual&dSortOrder=a
			*/
			if(!this.$GVO.isEmpty(this.objData)){
				let iCorpusCount = 0;
				let strHtmlFullSection = '';

				this.strHtmlCorpusName = '';
				this.strHtmlFloorNumbers = '';
				this.strHtmlAllSections = [];
				this.strHtmlAllSectionNames = [];

				for (const strCorpusName in this.objData) {
					if (this.objData.hasOwnProperty(strCorpusName)) {
						const masCorpus = this.objData[strCorpusName];
						iCorpusCount++;
						let iColSpan = Object.keys(masCorpus).length;
						if (iCorpusCount == 1){iColSpan = Object.keys(masCorpus).length + 1;}
						this.strHtmlCorpusName += '<td class="corpus-title-part pl-2" colspan="'+iColSpan+'"><p>'+strCorpusName+'</p></td>';
						for (const iSectionNumber in masCorpus) {
							const masSection = masCorpus[iSectionNumber];
							this.strHtmlAllSectionNames.push(iSectionNumber+' секция');
							for(let i=this.objFlatsPrintData.iMaxFloor;i>0;i--){
								let strRooms = '';
								let trclass = '';
								if (typeof masSection['floors'][i] != 'undefined'){
									strHtmlFullSection += '<div ><!-- '+masSection['floors_count']+' / '+i+'-->';
									for (let x=1;x<=masSection['flats_count_on_floor'];x++){
										if (typeof masSection['floors'][i][x] != 'undefined'){
											strRooms = masSection['floors'][i][x][0]['app_rooms'];
											strRooms = this.$GVO.str_replace(' ','',strRooms);
											strRooms = this.$GVO.str_replace('ккв','к',strRooms);
											strRooms = this.$GVO.str_replace('(Евро)','Е',strRooms);
											strRooms = this.$GVO.str_replace('Студия','С',strRooms);
											strRooms = this.$GVO.str_replace('К.пом','КП',strRooms);
											strRooms = this.$GVO.str_replace('Кладовка','КЛ',strRooms);
											strRooms = this.$GVO.str_replace('Коттедж','КОТ',strRooms);
											strRooms = this.$GVO.str_replace('Паркинг','ПАРК',strRooms);
											strRooms = this.$GVO.str_replace('ТаунХаус','ТАУН',strRooms);
											strRooms = this.$GVO.str_replace('Участок','УЧ',strRooms);

											if(masSection['floors'][i][x][0]['sold']!=1){trclass='sold';}
											if(masSection['floors'][i][x][0]['sold']==1){trclass='sell';}
											if(masSection['floors'][i][x][0]['app_stat']==3 && masSection['floors'][i][x][0]['sold']==1){trclass='bron';}											

											strHtmlFullSection += `
												<div class="cell ${trclass} row_${i}">
													<a href="/data/module/sso/object/flat/${masSection['floors'][i][x][0].app_id}${this.strDopGet}">
														<div class="section-row">
															<p>${strRooms}</p>
															<p>${masSection['floors'][i][x][0].app_stotal} м2</p>															
														</div>
														<p>${this.$GVO.formatAmount(parseFloat(masSection['floors'][i][x][0].app_flatcostwithdiscounts))}</p>
													</a>
												</div>
											`;
										}else{
											strHtmlFullSection += '<span class="cell hz row_'+i+'">&nbsp;</span>';
										}
									}
									strHtmlFullSection += '</div>';
								}else{
									strHtmlFullSection += '<div><!-- '+masSection['floors_count']+' / '+i+'-->';
									for (let x=1;x<=masSection['flats_count_on_floor'];x++){
										strHtmlFullSection += '<span class="cell hz row_'+i+'">&nbsp;</span>';
									}
									strHtmlFullSection += '</div>';
								}
							}
							this.strHtmlAllSections.push(strHtmlFullSection);
							strHtmlFullSection = '';
						}
					}
				}
				for (let i=this.objFlatsPrintData.iMaxFloor;i>0;i--){
					this.strHtmlFloorNumbers += '<div class="cell_floor row_'+i+'"><p>'+i+'</p></div>';
				}
			}
		}
	},
	mounted(){
		this.PrepareChessData();
	}
}
</script>
<style>
.ReSearchFlatsGrid {width: 100%; display: flex; border: 1px solid #01b0e0; border-radius: 6px; padding: 15px;}
.ReSearchFlatsGrid .flatsBody, .corpus-title, .grid-container {width: 100%;}
.ReSearchFlatsGrid table {border-spacing: 0; width: 100%;}
.ReSearchFlatsGrid p {margin: 0;}
.ReSearchFlatsGrid td {border: 1px solid #5c70a4;}
.ReSearchFlatsGrid .cell {border-bottom: 1px solid #5c70a4;}
.ReSearchFlatsGrid .cell:not(:last-child)  {border-right: 1px solid #5c70a4;}
.ReSearchFlatsGrid th {
	text-align: center;
    position: absolute;
    width: 3em;
    margin-left: -2.9em;
	margin-bottom: 1px;
}
.ReSearchFlatsGrid .cell, .fl-unit {height: 54px;}
.ReSearchFlatsGrid .cell.hz, .ReSearchFlatsGrid .cell.hz:hover{background-color: rgba(221, 221, 221, 0.22);}
.ReSearchFlatsGrid .cell.sold{background-color: rgba(230, 66, 66, 0.22);}
.ReSearchFlatsGrid .cell.bron{background-color: rgba(221, 202, 32, 0.28);}
.ReSearchFlatsGrid .cell.sell{background-color: rgba(52, 240, 108, 0.28);}
.ReSearchFlatsGrid .section-row {display: flex; justify-content: space-between; margin-bottom: 5px;}
.ReSearchFlatsGrid .cell {padding: 5px; white-space: nowrap; width: 125px;}
.ReSearchFlatsGrid .cell_floor, .ReSearchFlatsGrid .cell{height: 55px;}
.ReSearchFlatsGrid .fl-unit {display: flex; align-items: center; justify-content: center;}
.ReSearchFlatsGrid .floor {margin-bottom: 2px; border: 1px solid #5c70a4;}
.ReSearchFlatsGrid .grid-container {overflow: scroll; margin-left: 3em;}
.ReSearchFlatsGrid .section-title, .ReSearchFlatsGrid .floor {background: rgb(1, 176, 224, 0.33); text-align: center;}
.ReSearchFlatsGrid .corpus-title {position: sticky; top: 0; background: rgb(1, 191, 154, 0.33); padding-left: 10px;}
.ReSearchFlatsGrid .section-col>div{display: flex; justify-content: space-between;}
.ReSearchFlatsGrid .cell>a{display: block;}
.ReSearchFlatsGrid .cell:hover {background: rgb(1, 176, 224, 0.33);}
.ReSearchFlatsGrid .cell_floor {
	display: flex;
	align-items: center;
	justify-content: center;
	background: rgb(1, 176, 224, 0.33);
	font-weight: normal;
}
.ReSearchFlatsGrid .cell_floor:not(:last-child){border-bottom: 1px solid #5c70a4;}
.corpus-title-part:nth-child(even)  {background: rgb(186, 84, 245, 0.33)}
/*.corpus-title td, .section-title td {opacity: 0.8;}*/
</style>
